import { render, staticRenderFns } from "./Ideas_bank.vue?vue&type=template&id=60d7cc27"
import script from "./Ideas_bank.vue?vue&type=script&lang=js"
export * from "./Ideas_bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports